import fluid, { extract, screens, fontSize } from 'fluid-tailwind';

export default {
    content: {
        files: [
            './custom/blocks/**/*.{js,php}',
            './custom/templates/**/*.twig',
            './custom/js/**/*.js',
            './static/**/*.html',
        ],
        extract,
    },
    theme: {
        screens,
        fontSize,
        colors: {
            black: '#141412',
            white: '#FFFFFF',
            'gray-on-light': '#717171',
            'gray-on-dark': '#7f7f7f',
            'gray-light': '#E0E0E0',
            'gray-dark': '#4A4A44',
            green: '#407A3C',
            'green-dark': '#1D2A1B',
            'green-neon': '#81F235',
            slate: '#467281',
            transparent: 'transparent',
            current: 'currentColor',
        },
        fontFamily: {
            body: ['Stack Sans Text', 'sans-serif'],
            'body-lg': ['Stack Sans Headline', 'sans-serif'],
            heading: ['Space Grotesk', 'sans-serif'],
            utility: ['Space Mono', 'sans-serif'],
        },
        extend: {
            screens: {
                xs: '30rem', // 480px
                '3xl': '120rem', // 1920px
            },
        },
        fluid: ({ theme }) => ({
            defaultScreens: ['30rem', '90rem']
        }),
    },
    plugins: [
        require('@tailwindcss/container-queries'),
        fluid,
    ],
}

